const mainMenuEl = document.querySelector(".main-menu");
const mobileMenuTogglerEl = document.getElementById("mobileMenuToggler");
const mainMenuListWrapEl = document.querySelector(".main-menu__list-wrap");

if (mobileMenuTogglerEl !== null) {
	mobileMenuTogglerEl.addEventListener("click", function(event) {
		mainMenuEl.classList.toggle("main-menu--opened");
		mainMenuListWrapEl.classList.toggle("visible-mobile");
	});
}


